export enum RefundStatusEnum {
    Completed = 0,
    Pending = 1,
    Refunded = 2,
    PendingRefund = 3,
    Invalid = 5
}